"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Async = require("./Async");

var _Creatable = require("./Creatable");

var _stateManager = _interopRequireDefault(require("./stateManager"));

var _Select = _interopRequireDefault(require("./Select"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectCreatable = (0, _Creatable.makeCreatableSelect)(_Select.default);
var SelectCreatableState = (0, _stateManager.default)(SelectCreatable);

var _default = (0, _Async.makeAsyncSelect)(SelectCreatableState);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-select/lib/AsyncCreatable.js
// module id = 1556
// module chunks = 0